import React from "react"
import classes from "./styles.module.css"
import {FormattedMessage} from "react-intl";

const EmptyChart = () => {
    return (
        <div className={classes.EmptyChart}>
            <span><FormattedMessage id="EmptyChart.message" defaultMessage="no translate"/></span>
        </div>
    )
}

export default EmptyChart;


// WEBPACK FOOTER //
// ./src/PagesOfUser/Transactions/EmptyChart.js